import { useState } from "react";
import DatePicker from "react-datepicker";
import { Col, InputGroup, Label, Row } from "reactstrap";
import { DisabledDates } from "../../../../../Constant";
const DisabledDatePickerComponent = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const today = new Date();
  const disabledDates: Date[] = [today];

  return (
    <Row>
      <Col xxl="3">
        <Label className="box-col-12 text-start" check>
          {DisabledDates}
        </Label>
      </Col>
      <Col xxl="9" className="box-col-12">
        <InputGroup className="flatpicker-calender">
          <DatePicker className="form-control" selected={selectedDate} onChange={(date: Date | null) => setSelectedDate(date)} excludeDates={disabledDates} placeholderText="Select a date other than today or yesterday" />
        </InputGroup>
      </Col>
    </Row>
  );
};

export default DisabledDatePickerComponent;
